module.exports = __webpack_public_path__ + "img/new_face_ribbon.086cb9e6.svg";